import { useRuntimeConfig } from '#app';

/**
 * used to navigate to a specific path on different subdomains (hive.pb.example and have-trust.pb.example)
 * @param path
 * @param toTrust
 */
export function usePbRouter(path: string) {
    const config = useRuntimeConfig();

    return (window.location.href = config.public.pb.appDomain + path);
}
